import { render, staticRenderFns } from "./SiteNavDesktop.vue?vue&type=template&id=4fd3de8e&scoped=true&lang=pug&"
import script from "./SiteNavDesktop.vue?vue&type=script&lang=js&"
export * from "./SiteNavDesktop.vue?vue&type=script&lang=js&"
import style0 from "./SiteNavDesktop.vue?vue&type=style&index=0&id=4fd3de8e&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd3de8e",
  null
  
)

export default component.exports